import {GridColDef} from '@mui/x-data-grid';
import {t} from 'i18next';
import {CustomMenuItem} from '../common/arr-menu/ArrMenu';
import {
  ICreateByIdResponse,
  IEditAssignmentGroupByIdResponse,
  IEditAssignmentByIdResponse,
} from '../../api/types/assignment.type';
import {
  DocumentListSourceDetail,
  DocumentListSourceInfo,
  DocumentViewerListIdRequest,
} from '../../api/types/document.type';
import {SourceTypeCode} from '../../shared/constants';

export const assignmentsColumns = (): GridColDef[] => [
  {
    field: 'assignmentName',
    headerName: t('assignment.dataGrid.assignmentName'),
    headerClassName: 'typo-text label2_size',
    width: 174,
    flex: 1,
  },
  {
    field: 'isActive',
    headerName: t('assignment.dataGrid.status'),
    headerClassName: 'typo-text label2_size',
    width: 174,
    flex: 1,
  },
  {
    field: 'isCascadeEnabled',
    headerName: t('assignment.dataGrid.cascadedSettings'),
    headerClassName: 'typo-text label2_size',
    width: 174,
    flex: 1,
  },
  {
    field: 'classificationLabel',
    headerName: t('assignment.dataGrid.classification'),
    headerClassName: 'typo-text label2_size',
    width: 174,
    flex: 1,
  },
  {
    field: 'priority',
    headerName: t('assignment.dataGrid.priority'),
    headerClassName: 'typo-text label2_size',
    width: 174,
    flex: 1,
  },
  {
    field: 'isDrawFromPool',
    headerName: t('assignment.dataGrid.drawFromPool'),
    width: 174,
    flex: 1,
  },
  {
    field: 'totalDocuments',
    headerName: t('assignment.dataGrid.totalDocs'),
    headerClassName: 'typo-text label2_size',
    width: 174,
    flex: 1,
  },

  {
    field: 'generalPoolDocumentCount',
    headerName: t('assignment.dataGrid.generalPool'),
    width: 174,
    flex: 1,
  },
  {
    field: 'assignedDocuments',
    headerName: t('assignment.dataGrid.distributeToUser'),
    headerClassName: 'typo-text label2_size',
    width: 174,
    flex: 1,
  },
  {
    field: 'toBeReviewedDocuments',
    headerName: t('assignment.dataGrid.leftToDo'),
    headerClassName: 'typo-text label2_size',
    width: 174,
    flex: 1,
  },
  {
    field: 'completeCount',
    headerName: t('assignment.dataGrid.complete'),
    headerClassName: 'typo-text label2_size',
    width: 174,
    flex: 1,
  },
  {
    field: 'createdByUser',
    headerName: t('assignment.dataGrid.userCreated'),
    headerClassName: 'typo-text label2_size',
    width: 174,
    flex: 1,
  },
  {
    field: 'createdOn',
    headerName: t('assignment.dataGrid.dateCreated'),
    headerClassName: 'typo-text label2_size',
    width: 174,
    flex: 1,
  },
  {
    field: 'isAllowReviwerRemarks',
    headerName: t('assignment.dataGrid.reviewerRemarks'),
    headerClassName: 'typo-text label2_size',
    width: 174,
    flex: 1,
  },
  {
    field: 'isAllowPopoutPanels',
    headerName: t('assignment.dataGrid.documentMonitoring'),
    headerClassName: 'typo-text label2_size',
    width: 174,
    flex: 1,
  },
];

export const manage_reviewers = (
  renderActionsCell: (params: any) => React.ReactNode
) => {
  return [
    {
      field: '',
      headerName: '',
      width: 48,
      sortable: false,
      filterable: false,
      headerClassName: 'typo-text label2_size sticky-col left-col-header',
      cellClassName: 'action-cell sticky-col left-col-cell',
      renderCell: renderActionsCell,
    },
    {
      field: 'reviewerName',
      headerName: t('assignment.manageReviewers.reviewers'),
      flex: 1,
      headerClassName: 'typo-text label2_size',
    },
    {
      field: 'status',
      headerName: t('assignment.manageReviewers.status'),
      flex: 1,
      headerClassName: 'typo-text label2_size',
    },
    {
      field: 'assigned',
      headerName: t('assignment.manageReviewers.distributedToUser'),
      flex: 1,
    },
    {
      field: 'completed',
      headerName: t('assignment.manageReviewers.totalcompleted'),
      flex: 1,
    },
    {
      field: 'toDo',
      headerName: t('assignment.manageReviewers.leftToDo'),
      flex: 1,
    },
  ];
};

export const ASSIGNMENT_ACTION_MENU = [
  {
    id: 'new_Assignment',
    label: 'New Assignment',
    disabled: false,
  },
  {
    id: 'edit_Assignment',
    label: 'Edit Assignment',
    disabled: false,
  },
  {
    id: 'delete_Assignment',
    label: 'Delete Assignment',
    disabled: false,
  },
  {
    id: 'copy_Assignment',
    label: 'Copy Assignment',
    disabled: false,
  },
  {
    id: 'view',
    label: 'View',
    disabled: false,
    submenu: [
      {
        id: 'view_All_Docs_in_DocView',
        label: 'View in Doc View',
        disabled: false,
      },
      {
        id: 'view_in_DocView_in_new_tab',
        label: 'View in Doc View in New Tab',
        disabled: false,
      },
      {
        id: 'view_All_Docs_in_DocList',
        label: 'View in Doc List',
        disabled: false,
      },
    ],
  },
  {
    id: 'complete_All_Documents',
    label: 'Complete All Docs',
    disabled: false,
  },
  {
    id: 'uncomplete_All_Documents',
    label: 'Uncomplete All Docs',
    disabled: false,
  },
  {
    id: 'tag_All_Documents',
    label: 'Tag All Docs',
    disabled: false,
  },
  {
    id: 'folder_All_Documents',
    label: 'Folder All Docs',
    disabled: false,
  },
  {
    id: 'export_Metadata',
    label: 'Export Metadata',
    disabled: false,
  },
];

export const manageAssignmentsMoreMenu = (): CustomMenuItem[] => {
  const menuItems: CustomMenuItem[] = [
    {label: 'New Assignment Group', id: 'New_Assignment_Group'},
    {label: 'Edit Assignment Group', id: 'Edit_Assignment_Group'},
    {label: 'Delete Assignment Group', id: 'Delete_Assignment_Group'},
  ];
  return menuItems;
};

export const convertEditToCreate = (
  edit: IEditAssignmentGroupByIdResponse | undefined
): ICreateByIdResponse | undefined => {
  if (!edit) return;
  const amd = edit.assignmentModelData;

  const create: ICreateByIdResponse = {
    allowAIEnable: edit.allowAIEnable ?? false,
    unAssignedMetadata: edit.unAssignedMetadata ?? [],
    assignedMetadata: (edit.assignedMetadata as any) ?? [],
    codingFormsList:
      amd?.lstCodingForm?.map(({codingFormID, codingFormName}) => ({
        codingFormID,
        codingFormName,
      })) ?? [],
    userSecurityGroup: amd?.securityGroupID ?? 0,
    assignmentData: {
      projectID: amd?.projectID ?? 0,
      userID: amd?.userID ?? 0,
      securityGroupID: amd?.securityGroupID ?? 0,
      roleID: amd?.roleID ?? 0,
      isAssignmentGroup: amd?.isAssignmentGroup ?? false,
      assignmentID: amd?.assignmentID ?? 0,
      cascadeAssignmentID: amd?.cascadeAssignmentID ?? 0,
      assignmentInstructions: amd?.assignmentInstructions ?? '',
      assignmentName: amd?.assignmentName ?? '',
      parentAssignmentGroupID: amd?.parentAssignmentGroupID ?? 0,
      parentassignmentGroupName: amd?.parentassignmentGroupName ?? '',
      isCascadeEnabled: amd?.isCascadeEnabled ?? false,
      classificationLevelID: amd?.classificationLevelID ?? 0,
      parentsIsCascadeEnabled: amd?.parentsIsCascadeEnabled ?? false,
      codingFormID: amd?.codingFormID ?? 0,
      isActive: amd?.isActive ?? false,
      priority: amd?.priority ?? 1,
      isDrawFromPool: amd?.isDrawFromPool ?? false,
      drawFromPoolCount: amd?.drawFromPoolCount ?? 0,
      isKeepFamiliesTogether: amd?.isKeepFamiliesTogether ?? false,
      isKeepEmailThreadsTogether: amd?.isKeepEmailThreadsTogether ?? false,
      keepFamiliesTogetherCount: amd?.keepFamiliesTogetherCount ?? 0,
      additionalPreferences: {
        ...(amd?.additionalPreferences ?? {}),
      },
      docPresentationSorting: {
        isCategory: amd?.docPresentationSorting?.isCategory ?? false,
        lstCategorySeq: amd?.docPresentationSorting?.lstCategorySeq ?? [],
        lstNotAssignedCategorySeq:
          amd?.docPresentationSorting?.lstNotAssignedCategorySeq ?? [],
        isMetadata: amd?.docPresentationSorting?.isMetadata ?? false,
        lstMetaDataFieldModel:
          amd?.docPresentationSorting?.lstMetaDataFieldModel ?? [],
        lstUnAssignMetaDataFieldModel:
          amd?.docPresentationSorting?.lstUnAssignMetaDataFieldModel ?? [],
        selectedMetaDataFieldId:
          amd?.docPresentationSorting?.selectedMetaDataFieldId ?? 0,
        metaDataSeq: amd?.docPresentationSorting?.metaDataSeq ?? 0,
        metaDataDirection:
          amd?.docPresentationSorting?.metaDataDirection ?? false,
        isImportList: amd?.docPresentationSorting?.isImportList ?? false,
        lstDocIdList: amd?.docPresentationSorting?.lstDocIdList ?? [],
        isAIScore: amd?.docPresentationSorting?.isAIScore ?? false,
        lstSelectedAiScore:
          amd?.docPresentationSorting?.lstSelectedAiScore ?? [],
        selectedModelAiScoreId:
          amd?.docPresentationSorting?.selectedModelAiScoreId ?? 0,
        aiScoreModelDirection:
          amd?.docPresentationSorting?.aiScoreModelDirection ?? false,
        shouldDisplayEmailTogether:
          amd?.docPresentationSorting?.shouldDisplayEmailTogether ?? false,
        shouldDisplayFamilyTogether:
          amd?.docPresentationSorting?.shouldDisplayFamilyTogether ?? false,
        aiChkForFamilyTogether:
          amd?.docPresentationSorting?.aiChkForFamilyTogether ?? false,
        aiChkForEmailsTogether:
          amd?.docPresentationSorting?.aiChkForEmailsTogether ?? false,
        metadatChkForFamilyTogether:
          amd?.docPresentationSorting?.metadatChkForFamilyTogether ?? false,
        metadataChkForEmailsTogether:
          amd?.docPresentationSorting?.metadataChkForEmailsTogether ?? false,
      },
      lstReviewerModel: amd?.lstReviewerModel ?? [],
      lstRUNotAssignedModel: amd?.lstRUNotAssignedModel ?? [],
      lstKeywordsModel: amd?.lstKeywordsModel ?? [],
      selectCodingFormLists: JSON.stringify(amd?.selectCodingFormLists ?? []),
      pageSize: amd?.pageSize ?? 0,
      pageNumber: amd?.pageNumber ?? 1,
      isAscending: amd?.isAscending ?? 'true',
      sortingColumn: amd?.sortingColumn ?? '',
      totalDocuments: amd?.totalDocuments ?? 0,
      unAssignedDocuments: amd?.unAssignedDocuments ?? 0,
      noOfDocToDistribute: amd?.noOfDocToDistribute ?? 0,
      assignmentKeywordIds:
        amd?.assignmentKeywordIds ??
        amd?.assignmentKeywordIdList?.map((item) => String(item.keywordID)) ??
        [],
      assignmentMetaDataIds: amd?.assignmentMetaDataIds ?? [],
      assignmentMetaDataIdsList: amd?.assignmentMetaDataIdsList ?? [],
      assignmentKeywordIdList: amd?.assignmentKeywordIdList ?? [],
      lstCodingForm: amd?.lstCodingForm ?? [],
      isTemporary: amd?.isTemporary ?? false,
      isLockNeeded: amd?.isLockNeeded ?? false,
      isAIEnabled: amd?.isAIEnabled ?? false,
      distributeFamilyDocuments: amd?.distributeFamilyDocuments ?? false,
      distributeEmailThreadDocuments:
        amd?.distributeEmailThreadDocuments ?? false,
    },

    // Edit response doesn't include classification; keep empty unless you source it elsewhere.
    classification: [],
    assignedUsers: [],
  } as any;

  return create;
};

export const convertEditAssignmentData = (
  editData: IEditAssignmentByIdResponse | undefined
) => {
  if (!editData) return;
  const create: ICreateByIdResponse = {
    allowAIEnable: editData.allowAIEnable ?? false,
    unAssignedMetadata:
      editData.unAssignedMetaData.map((item) => ({
        ...item,
        text: item.value,
        selectedValue: '',
      })) ?? [],
    assignedMetadata:
      editData.assignedMetadata.map((item) => ({
        ...item,
        text: item.value,
        selectedValue: '',
        htmlAttributes: {
          title: item.value,
        },
      })) ?? [],
    codingFormsList: editData?.codingFormsList ?? [],
    assignmentData: {
      isAssignmentGroup: editData?.isAssignmentGroup ?? false,
      assignmentID: editData?.assignmentId ?? 0,
      assignmentInstructions: editData?.assignmentInstructions ?? '',
      assignmentName: editData?.assignmentName ?? '',
      parentAssignmentGroupID: editData?.parentGroupId ?? 0,
      parentassignmentGroupName: editData?.parentGroupName ?? '',
      isCascadeEnabled: editData?.isCascadeEnabled ?? false,
      classificationLevelID: editData?.classificationLevelId ?? 0,
      parentsIsCascadeEnabled: editData?.parentsIsCascadeEnabled ?? false,
      isActive: editData?.isActive ?? false,
      priority: editData?.priority ?? 1,
      isDrawFromPool: editData?.isDrawFromPool ?? false,
      drawFromPoolCount: editData?.drawFromPoolCount ?? 0,
      isKeepFamiliesTogether: editData?.isKeepFamiliesTogether ?? false, //need to check this field
      isKeepEmailThreadsTogether: editData?.isKeepEmailThreadsTogether ?? false,
      keepFamiliesTogetherCount: editData?.keepFamiliesTogetherCount ?? 0,
      additionalPreferences: editData?.additionalPreferences,
      docPresentationSorting: {
        isCategory: editData?.docPresentationSorting?.isCategory ?? false,
        lstCategorySeq: editData?.docPresentationSorting?.lstCategorySeq ?? [],
        lstNotAssignedCategorySeq:
          editData?.docPresentationSorting?.lstNotAssignedCategorySeq ?? [],
        isMetadata: editData?.docPresentationSorting?.isMetadata ?? false,
        lstMetaDataFieldModel:
          editData?.docPresentationSorting?.lstMetaDataFieldModel ?? [],
        lstUnAssignMetaDataFieldModel:
          editData?.docPresentationSorting?.lstUnAssignMetaDataFieldModel ?? [],
        selectedMetaDataFieldId:
          editData?.docPresentationSorting?.selectedMetaDataFieldId ?? 0,
        metaDataSeq: editData?.docPresentationSorting?.metaDataSeq ?? 0,
        metaDataDirection:
          editData?.docPresentationSorting?.metaDataDirection ?? false,
        isImportList: editData?.docPresentationSorting?.isImportList ?? false,
        lstDocIdList: editData?.docPresentationSorting?.lstDocIdList ?? [],
        isAIScore: editData?.docPresentationSorting?.isAIScore ?? false,
        lstSelectedAiScore:
          editData?.docPresentationSorting?.lstSelectedAiScore ?? [],
        selectedModelAiScoreId:
          editData?.docPresentationSorting?.selectedModelAiScoreId ?? 0,
        aiScoreModelDirection:
          editData?.docPresentationSorting?.aiScoreModelDirection ?? false,
        shouldDisplayEmailTogether:
          editData?.docPresentationSorting?.shouldDisplayEmailTogether ?? false,
        shouldDisplayFamilyTogether:
          editData?.docPresentationSorting?.shouldDisplayFamilyTogether ??
          false,
        aiChkForFamilyTogether:
          editData?.docPresentationSorting?.aiChkForFamilyTogether ?? false,
        aiChkForEmailsTogether:
          editData?.docPresentationSorting?.aiChkForEmailsTogether ?? false,
        metadatChkForFamilyTogether:
          editData?.docPresentationSorting?.metadatChkForFamilyTogether ??
          false,
        metadataChkForEmailsTogether:
          editData?.docPresentationSorting?.metadataChkForEmailsTogether ??
          false,
      },
      lstReviewerModel: [],
      lstRUNotAssignedModel: [],
      lstKeywordsModel: editData?.assignmentKeywordIds ?? [],
      selectCodingFormLists: JSON.stringify(
        editData?.selectedCodingFormList
          .filter((item) => item.isSelected)
          .sort((a, b) => a.sortOrder - b.sortOrder) ?? []
      ),
      pageSize: 0,
      pageNumber: 1,
      isAscending: 'true',
      sortingColumn: '',
      totalDocuments: 0,
      unAssignedDocuments: 0,
      noOfDocToDistribute: 0,
      assignmentKeywordIds:
        editData?.assignmentKeywordIds
          ?.filter((item) => item.keywordStatus)
          .map((item: any) => String(item.keywordID)) ?? [],
      assignmentMetaDataIds: (editData?.assignmentMetaDataIds as any) ?? [],
      lstCodingForm: editData?.codingFormsList ?? [],
      isAIEnabled: editData?.isAIEnabled ?? false,
    } as any,
    classification: (editData?.classification as any) ?? [],
  } as any;

  return create;
};

export interface CreateDocumentViewerListRequestPayloadArgsFromAssignments {
  totalDocumentToView: DocumentListSourceInfo['totalDocumentToView'];
  selectedAssignmentName?: DocumentListSourceInfo['selectedAssignmentName'];
  sourceID: DocumentListSourceDetail['sourceID'];
  objSourceOverrides?: Partial<DocumentListSourceInfo>;
}

export const createDocumentViewerListRequestPayloadFromAssignments = (
  args: CreateDocumentViewerListRequestPayloadArgsFromAssignments
): DocumentViewerListIdRequest => {
  const objSource = {
    // Required
    totalDocumentToView: args.totalDocumentToView,
    sourceTypeCode: SourceTypeCode.ASSIGNMENT,
    sourceDetails: [{sourceID: args.sourceID} as never],
    assignmentSource: 'MANAGEASSIGNMENT',
    selectedAssignmentName: args?.selectedAssignmentName ?? '',
    isDefaultLoad: true,
    isDocumentCount: false,
    destinationContextTypeCode: 'DOCVIEW',

    userID: 0,
    securityGroupID: 0,
    roleID: 0,
    projectID: 0,
    docsToExclude: [],
    sqlUnitParam: [],
    columnFilters: [],
    destinationTypeCode: '',
    sampleMethod: '',
    stR_SelectedSearchIds: [],
    reportID: '',
    prevPageName: '',
    dataSetStatus: '',
    ...(args?.objSourceOverrides ?? {}),
  };

  return {
    objSource: objSource as never,
    docViewSessionObject: {
      sortconfiguration: {
        optimizedCols: '',
        optimizedSelectFieldIDs: '',
        optimizedSelectFieldOrder: '',
        manualCols: 'string',
        manualSelectFieldIDs: '',
        manualSelectFieldOrder: '',
        selectFields: '',
        configuredCols: '',
        order: '',
        showCompletedDocOptimized: false,
        showCompletedDocManual: false,
        configuredShowCompletedDoc: false,
        selectFieldTemp: '',
        selectFieldDataTypeOptimized: [],
        selectFieldDataType: [],
        selectFieldDataTypeManual: [],
        redirectionType: 0,
        manualOrder: '',
      },
      assignmentSortDetails: [
        {
          sourceID: args.sourceID,
          columnManual: '',
          columnOptimized: '',
          columnIDsOptimized: '',
          columnOrderOptimized: '',
          columnIDsManual: '',
          columnOrderManual: '',
          showCompletedOptimized: true,
          showCompletedManual: false,
          configuredShowCompletedDoc: false,
          columnDisplayManual: '',
          columnDataTypeOptimized: [],
          columnDataTypeManual: [],
        },
      ],
      sourceTypeCode: objSource.sourceTypeCode,
      backtoSrcSourceTypeCode: objSource.sourceTypeCode,
      sourceID: args.sourceID,
      backtoSrcSourceId: args.sourceID,
      assignmentSource: 'MANAGEASSIGNMENT',
      xmlCompletedDocumentEditedCodingForm: '',
      docsForCodeSame: [],
    } as never,
    sortConfigurationDocView: {
      optimizedCols: '',
      optimizedSelectFieldIDs: '',
      optimizedSelectFieldOrder: '',
      manualCols: 'string',
      manualSelectFieldIDs: '',
      manualSelectFieldOrder: '',
      selectFields: '',
      configuredCols: '',
      order: '',
      selectFieldTemp: '',
      selectFieldDataTypeOptimized: [],
      selectFieldDataType: [],
      selectFieldDataTypeManual: [],
      manualOrder: '',
    } as never,
    defaultAssName: '',
    sortConfigDocView: {
      optimizedCols: '',
      optimizedSelectFieldIDs: '',
      optimizedSelectFieldOrder: '',
      manualCols: '',
      manualSelectFieldIDs: '',
      manualSelectFieldOrder: '',
      selectFields: '',
      configuredCols: '',
      order: '',
      showCompletedDocOptimized: false,
      showCompletedDocManual: false,
      configuredShowCompletedDoc: false,
      selectFieldTemp: '',
      selectFieldDataTypeOptimized: [],
      selectFieldDataType: [],
      selectFieldDataTypeManual: [],
      manualOrder: '',
    } as never,
  } as never;
};
